// Copyright: IQGeo Limited 2010-2022
// All styles
//
// Provided to simplify imports

import SimpleStyle from './simpleStyle';
import PointStyle from './pointStyle';
import SymbolStyle from './symbolStyle';
import IconStyle from './iconStyle';
import LineStyle from './lineStyle';
import FillStyle from './fillStyle';
import TextStyle from './textStyle';
import LookupStyle from './lookupStyle';
import Style from './style';

//here to avoid circular dependency
Style.newFrom = function (options) {
    if (!options) return;
    else if (options.lookupProp || options.defaultStyle) {
        const { lookup: lookupData, ...others } = options;
        const lookup = {};
        for (let key in lookupData) {
            lookup[key] = Style.newFrom(lookupData[key]);
        }
        return new LookupStyle({ ...others, lookup });
    } else if (options.iconUrl) return new IconStyle(options);
    else if (options.symbol) return new SymbolStyle(options);
    else if (options.lineStyle) return new LineStyle(options);
    else if (options.text || options.textProp) return new TextStyle(options);
    else return new FillStyle(options);
};

export {
    SimpleStyle,
    PointStyle,
    SymbolStyle,
    IconStyle,
    LineStyle,
    FillStyle,
    TextStyle,
    Style,
    LookupStyle
};
export default {
    SimpleStyle,
    PointStyle,
    SymbolStyle,
    IconStyle,
    LineStyle,
    FillStyle,
    TextStyle,
    Style,
    LookupStyle
};
